export default __webpack_public_path__ + "static/media/KH.905c78d3.svg";